var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.065,
    height: 42.066,
    viewBox: "0 0 42.065 42.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2904",
    "data-name": "Group 2904",
    transform: "translate(0.2 0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2904-2",
    "data-name": "Group 2904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3659",
    "data-name": "Path 3659",
    d: "M649.157,19.253a20.841,20.841,0,1,1-4.417-4.436l3.656-3.656a.531.531,0,0,1,.906.361l.082,3.012,3.141.085a.53.53,0,0,1,.361.905Zm-5.121-3.636a19.779,19.779,0,1,0,4.281,4.287h-.047l-3.329-.09a.533.533,0,0,1-.156.072l-1.54,1.54a14.892,14.892,0,1,1-.75-.75l1.61-1.611-.089-3.29A.527.527,0,0,1,644.036,15.617Zm4.294-.776-.056-2.057-3.191,3.191.056,2.057Zm-2.341,3.94,2.083.057,3.19-3.191-2.084-.057Zm-4.244,2.645a13.841,13.841,0,1,0,.75.751L638.9,25.771a8.754,8.754,0,1,1-.751-.75ZM637.4,25.773a7.685,7.685,0,1,0,.75.75l-3.219,3.219a3.156,3.156,0,1,1-.75-.75Zm-3.986,3.985a2.091,2.091,0,1,0,.751.75l-1.432,1.432a.531.531,0,0,1-.751-.75Z",
    transform: "translate(-611.522 -10.733)",
    fill: "#2323e5",
    stroke: "#2323e5",
    strokeWidth: 0.4,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.6961c684cd24eaec2f0fdd5d947d65a0.svg";
export { ForwardRef as ReactComponent };